export enum ISSUE_TYPES {
  IRRITATED_CUSTOMER = 'IRRITATED_CUSTOMER',
  AGENT_MISCONDUCT = 'AGENT_MISCONDUCT',
  SLA_BREACHED = 'SLA_BREACHED',
}

export const ISSUE_TYPES_LABELS = {
  [ISSUE_TYPES.IRRITATED_CUSTOMER]: 'Irritated Customer',
  [ISSUE_TYPES.AGENT_MISCONDUCT]: 'Agent Misconduct',
  [ISSUE_TYPES.SLA_BREACHED]: 'SLA Breached',
};

export enum ACTION_TYPES {
  ALL = 'all',
  PENDING = 'pending',
  RESOLVED = 'resolved',
  NOT_AN_ISSUE = 'not-an-issue',
  IN_PROGRESS = 'in-progress',
}

export const ACTION_TYPES_LABELS = {
  [ACTION_TYPES.ALL]: 'Status',
  [ACTION_TYPES.PENDING]: 'Pending',
  [ACTION_TYPES.RESOLVED]: 'Resolved',
  [ACTION_TYPES.NOT_AN_ISSUE]: 'Not an Issue',
  [ACTION_TYPES.IN_PROGRESS]: 'In Progress',
};

export interface cxOverview {
  id: string;
  incident: string;
  state: ACTION_TYPES;
  chatMessageId: string;
  chatTypeId: string;
  dateCreated: string;
  dateUpdated: string;
  issue: string;
  issueColorCode: string;
  customerName: string;
  customerPhoneNumber: string;
  userName: string;
  messageText: string;
  wabaNumber: string;
}
export interface CxOverviewMetricsType {
  perState: Record<string, number>;
  totalIncidents: number;
}
export interface CxOverviewMetricsAPIResponseType extends CxOverviewMetricsType {
  isLoading: boolean;
}
export interface cxOverviewPaginationData {
  hasMore: boolean;
  nextLastDateCreated: string | null;
  nextLastId: string | null;
}

export interface CxIssuesType {
  id: string;
  name: string;
  colorCode: string;
  enabled: boolean;
}
export interface CxIssuesListAPIResponseType {
  data: CxIssuesType[];
}
